import { faFolderOpen, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'
// import {
//     BrowserView,
//     MobileView,
//     isBrowser,
//     isMobile
// } from "react-device-detect";
import { COLOR_APP } from '../constants';

export default function EmptyComponent({ title, subTitle, isButton, buttonTitle, buttonIcon, buttonOnClick }) {
    return (
        <div style={{ height: '60vh', width: '100%', display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <p style={{ color: "#616161", fontSize: 40, textAlign: 'center' }} >{title}</p>
            <p style={{ color: "#cccccc", fontSize: 30, textAlign: 'center' }} >{subTitle}</p>
            {isButton && <button className={"btn btn-app hoverme"} style={{ background: COLOR_APP, color: "#fff", borderRadius: 5, height: 50, width: 150, marginBottom: 32, marginTop: 32 }} onClick={buttonOnClick}>
                {buttonIcon && <FontAwesomeIcon icon={buttonIcon} />} {buttonTitle}
            </button>}
            <img src={"/images/add_product.png"} style={{ width: "auto", height: "30vh" }} />
        </div>
    )
}
